/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import styled from 'styled-components'
import AtomicDrawerHeader from '../../../atomic/DrawerHeader'

const StyledDrawerHeader = styled(AtomicDrawerHeader)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;

  > span {
    color: #373737 /* character/primary */;
    font-weight: var(--typography-weight-bold);
    font-size: 20px;
    line-height: 28px;
  }

  > svg {
    cursor: pointer;
    color: #616161 /* character/secondary */;
    height: 20px;
    width: 20px;
    flex: 0 0 auto;
  }
`

const DrawerHeaderLogic = ({
  Wrapper,
  onClose,
}: {
  Wrapper: any
  onClose: () => void
}) => {
  const { copies } = useHeaderContext()
  const { clients } = copies || {}
  const { user } = clients?.generalheader || {}

  return <Wrapper onClose={onClose} copy={user?.account} />
}

const DrawerHeader = ({ onClose }: { onClose: () => void }) => (
  <DrawerHeaderLogic Wrapper={StyledDrawerHeader} onClose={onClose} />
)

export default DrawerHeader
